export const environment = {
    production: 'false',
    appBaseHref: '/',
    oidc: {
      clientId: '0oa6aebhtgVt0mIfE4h7',
      issuer: 'https://relayhealth.okta.com/oauth2/aus6a5yiuiwuMMlZD4h7',
      redirectUri: 'login/callback',
      scopes: ['openid'],
      pkce: false
    },
    resourceServer: {
      messagesUrl: ''
    },
    transactionListUrl: 'https://rxosupport-api-uat.relayhealth.com/transaction-list',
    transactionLookupUrl:'https://rxosupport-api-uat.relayhealth.com/transaction-lookup',
    pharmacyCrudUrl:'https://rxosupport-api-uat.relayhealth.com/pharmacy-crud',
    pharmacyListUrl:'https://rxosupport-api-uat.relayhealth.com/pharmacy-list',
    pharmacyLookupUrl:'https://rxosupport-api-uat.relayhealth.com/pharmacy-lookup',
    pharmacyStoresCrudUrl:'https://rxosupport-api-uat.relayhealth.com/pharmacy-stores-crud',
    configUIAPIUrl:'https://rxosupport-api-uat.relayhealth.com/config-ui-api',
    testConnectivityUrl:'https://rxosupport-api-uat.relayhealth.com/config-ui-api/testconnectivity'
  };